var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_setup.loading),expression:"loading"}],staticClass:"apitable-container"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_setup.url,"width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }